import { Select, Tooltip, Divider } from 'antd'
import { useState, useMemo } from 'react'
import UMCCheckbox from './UMCCheckbox'

const MultiSelectFilter = (props) => {
    const [value, setValue] = useState([])

    /** Build dropdown filter options + collect all enum values in one pass **/
    const {filterOptions, allEnumValues} = useMemo(() => {
        const options = (props.enum || []).map((option) => ({
            value: option.value,
            labelText: option.label,
            label: (
                <UMCCheckbox
                    value={value.includes(option.value)}
                    label={
                        <span className="dropdown-option-text" title={option.label}>
                            {option.label}
                        </span>
                    }
                />
            ),
        }))

        return {
            filterOptions: options,
            allEnumValues: options.map((opt) => opt.value),
        }
    }, [props.enum, value])

    // const allEnumValues = useMemo(() => filterOptions.map(opt => opt.value), [filterOptions]) //collects all possible Enum values
    const allSelected = allEnumValues.length > 0 && allEnumValues.every(v => value.includes(v)) //checks whether the user has selected everything

    /** Toggle Select All **/
    const toggleSelectAll = (e) => {
        e.stopPropagation() // keep dropdown open
        const updatedValues = allSelected ? [] : allEnumValues
        setValue(updatedValues)
        props.handleSelect?.(updatedValues)
    }

    const handleDropdownSelection = (selectedValues) => {
        setValue(selectedValues)
        props.handleSelect?.(selectedValues)
    }

    const handleClear = () => {
        setValue([])
        props.handleSelect?.([])
    }

    return (
        <div onClick={e => e.stopPropagation()}>
            <Select
                mode="multiple"
                showSearch
                value={value}
                optionLabelProp="labelText"
                placeholder={props.placeholder}
                onChange={handleDropdownSelection}
                onClear={handleClear}
                menuItemSelectedIcon={null}
                filterOption={(input, option) =>
                    (option?.labelText || '').toLowerCase().includes(input.toLowerCase())
                }
                maxTagCount="responsive"
                maxTagPlaceholder={(omittedValues) => {
                    // Pre-build a lookup map for quick access
                    const optionMap = new Map(filterOptions.map(opt => [opt.value, opt.labelText]))

                    const tooltipTitle = omittedValues
                        .map(item => optionMap.get(item.value) || item.label || item.value)
                        .join(', ')

                    return (
                        <Tooltip title={tooltipTitle}>
                            <span style={{ cursor: 'pointer' }}>
                                + {omittedValues.length} ...
                            </span>
                        </Tooltip>
                    )
                }}
                className={`tbl-col-search ${props.className || ''} ${props.parentClassName || ''}`}
                popupClassName={`custom-dropdown ${props.popupClassName || ''}`}
                dropdownRender={(menu) => (
                    <>
                        {/* "Select All" row styled as an AntD option */}
                        <div
                            className="ant-select-item ant-select-item-option select-all-option"
                            onClick={toggleSelectAll}
                        >
                            <div className="ant-select-item-option-content">
                                <UMCCheckbox value={allSelected} label="Select All" />
                            </div>
                        </div>

                        <Divider style={{ margin: 0 }} />
                        {menu}
                    </>
                )}
                options={filterOptions}
            />
        </div>
    )
}

export default MultiSelectFilter
